import React, { Component } from "react";

import {
  Row,
  Wrapper,
  Copy,
  ExternalImage,
  Video
} from "app/NativeComponents/common";

import { renderDate } from "app/NativeActions";
class FromTextMessage extends Component {
  componentDidMount() {
    if (!this.props.read_message) {
      this.props.readTextMessage({
        token: this.props.token,
        message_id: this.props.message_id,
        conversation_id: this.props.conversation_id,
        lead_id: this.props.lead_id
      });
    }
  }

  renderUnreadMessageAlert() {
    if (!this.props.read_message) {
      return (
        <Wrapper
          style={{
            position: "absolute",
            width: 10,
            height: 10,
            bottom: -2,
            right: -2
          }}
        >
          <Wrapper
            style={{
              width: 10,
              height: 10,
              borderRadius: 5,
              backgroundColor: this.props.colors.active_color
            }}
          />
        </Wrapper>
      );
    }
  }

  renderMedia() {
    const { media } = this.props;
    if (media && media.length > 0) {
      return (
        <Wrapper>
          {media.map((item, i) => {
            switch (item.content_type) {
              case "image/jpeg":
              case "image/jpg":
              case "image/png":
                return (
                  <Wrapper key={"media_" + i}>
                    <ExternalImage
                      style={{
                        width: this.props.device == "desktop" ? "100%" : 200,
                        maxWidth: 300,
                        height: this.props.device == "desktop" ? "auto" : 200,
                        resizeMode: "contain"
                      }}
                      contain
                      image={item.url}
                    />
                  </Wrapper>
                );

              case "video/3gpp":
              case "video/mp4":
              case "video/mov":
                return (
                  <Wrapper key={"media_" + i}>
                    <Video
                      video={item.url}
                      height={this.props.device == "desktop" ? 270 : 180}
                      width={this.props.device == "desktop" ? 480 : 320}
                      autoPlay={false}
                      controls={true}
                    />
                  </Wrapper>
                );
              default:
                break;
            }

            return <Wrapper key={"media_" + i} />;
          })}
        </Wrapper>
      );
    }
  }

  render() {
    const { message_text, date_created, colors } = this.props;
    return (
      <Wrapper style={{ marginRight: 5 }}>
        <Row style={{ justifyContent: "flex-start" }}>
          <Wrapper style={{}}>
            <Wrapper
              style={{
                margin: 10,
                marginBottom: 5,
                marginRight: 30,
                padding: 15,
                backgroundColor: colors.gray_color,
                borderRadius: 10,
                borderBottomLeftRadius: 0,
                position: "relative"
              }}
            >
              <Copy style={{ color: colors.text_color }}>{message_text}</Copy>
              {this.renderMedia()}
              {this.renderUnreadMessageAlert()}
            </Wrapper>
            <Wrapper
              style={{
                margin: 10,
                marginTop: 0,
                marginBottom: 0,
                alignItems: "flex-start"
              }}
            >
              <Copy style={{ color: colors.light_text_color, fontSize: 10 }}>
                {date_created ? renderDate(date_created, false, "time") : ""}
              </Copy>
            </Wrapper>
          </Wrapper>
        </Row>
      </Wrapper>
    );
  }
}

export default FromTextMessage;
